import React, { useEffect, useState } from 'react';
import { axiosInstance } from "../../utils/axios.js";
import { FaCheckCircle } from "react-icons/fa";
import { MapPin, Plus, Home, Trash2, Star, CheckCircle, Edit } from 'lucide-react';
import { RxRows } from 'react-icons/rx';

const MypageAddressContainer = (props) => {
  const [addressList, setAddressList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isFormValid, setIsFormValid] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [completeModal, setCompleteModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [address, setAddress] = useState('');
  const [zip, setZip] = useState('');
  const [apartment, setApartment] = useState('');
  const [sentence, setSentence] = useState('');
  const [editingAddress, setEditingAddress] = useState(null);

  useEffect(() => {
    axiosInstance.get('/delivers/1', {
      headers: {
        'uid': props.token,
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(response => {
        setAddressList(response.data);
        setIsLoading(false);
      });
  }, []);

  const deleteAddress = (id) => {
    axiosInstance.delete(`/delivers/${id}`, {
      headers: {
        'uid': props.token,
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(response => {
        setAddressList(response.data);
        setSentence('削除');
        setCompleteModal(true);
      });
  };

  const updateMainAddress = (id) => {
    axiosInstance.put(`/delivers/${id}`, {}, {
      headers: {
        'uid': props.token,
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(response => {
        setAddressList(response.data);
        setSentence('更新');
        setCompleteModal(true);
      });
  };

  // 住所編集機能
  const openEditModal = (addressItem) => {
    setEditingAddress(addressItem);
    setZip(addressItem.zip);
    setAddress(addressItem.address);
    setApartment(addressItem.apartment || '');
    setEditModal(true);
  };

  const updateAddress = () => {
    axiosInstance.put(`/delivers/${editingAddress.id}`, {
      zip,
      address,
      apartment
    }, {
      headers: {
        'uid': props.token,
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(response => {
        setAddressList(response.data);
        setEditModal(false);
        setSentence('編集');
        setCompleteModal(true);
        resetForm();
      });
  };

  useEffect(() => {
    validateForm();
  }, [zip, address]);

  const validateForm = () => {
    setIsFormValid(zip.trim() !== '' && address.trim() !== '');
  };

  const createAddress = () => {
    axiosInstance.post(`/delivers`, { zip, address, apartment }, {
      headers: {
        'uid': props.token,
        'Access-Control-Allow-Origin': '*'
      }
    })
      .then(response => {
        setAddressList(response.data);
        setShowModal(false);
        setSentence('新規作成');
        setCompleteModal(true);
        resetForm();
      });
  };

  const resetForm = () => {
    setZip('');
    setAddress('');
    setApartment('');
    setEditingAddress(null);
  };

  const closeModal = () => {
    setShowModal(false);
    setCompleteModal(false);
    setEditModal(false);
    resetForm();
  };

  return (
    <div className="sunny_container" style={{paddingBottom:'120px'}}>
      <div className="mypage_address">
        {addressList.length == 0 ? (
          <div className="empty_address_state">
            <MapPin className="empty_icon" />
            <p className="empty_title">配送先住所がありません</p>
          </div>
        ) : (
          <div>
            <div className="address_header">
              <MapPin className="address_header_icon" />
              <h1 className="mypage_reservation_h1">配送先住所確認・編集</h1>
            </div>

            <button className="add_address_button" onClick={() => setShowModal(true)}>
              <Plus className="button_icon" />
              新しい住所を追加
            </button>

            <div className="address_list">
              {addressList.map((item, index) => (
                <div className={`address_card ${item.preset ? 'main_address' : ''}`} key={index}>
                  <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                    <div className="address_card_header" style={{marginTop:'0px',display:'flex',flexDirection:'row'}}>
                      <div className="address_icon_container" style={{display:'flex',flexDirection:'row',justifyContent:'space-between',marginTop:'0px'}}>
                        {item.preset && (
                          <div>
                            <span className="main_badge" style={{display:'flex',alignItems:'center'}}>
                              <Star style={{width:'auto',height:'20',marginRight:'6px'}} />
                              メイン住所
                            </span>
                          </div>
                        )}
                      </div>
                                                                {/* 編集ボタンを追加 */}
                      {!item.preset && (
                        <button 
                          className="address_action_button" 
                          onClick={() => updateMainAddress(item.id)}
                          style={{padding:'0.1rem 0.4rem',fontSize:'0.6rem'}}
                        >
                          <span className="main_badge" style={{display:'flex',alignItems:'center',background:'transparent',color:'black'}}>
                            メイン住所に登録
                          </span>
                        </button>
                    )}
                    </div>

                    <div className="address_actions" style={{justifyContent: 'space-between',marginBottom:'12px',width:'30%'}}>
                      <button 
                        className="address_action_button edit" 
                        onClick={() => openEditModal(item)}
                        title="この住所を編集"
                      >
                        編集
                      </button>

                      {addressList.length > 1 && (
                        <button 
                          className="address_action_button delete subtle" 
                          onClick={() => deleteAddress(item.id)}
                          title="この住所を削除"
                        >
                          <Trash2 className="action_icon" />
                        </button>
                      )}
                    </div>
                  </div>
                  
                  <div className="address_details">
                    <p className="address_zip">〒 {item.zip}</p>
                    <p className="address_main">{item.address}</p>
                    {item.apartment && <p className="address_sub">{item.apartment}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 完了モーダル */}
        {completeModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content success_modal" onClick={(e) => e.stopPropagation()}>
              <span className="close-button" onClick={closeModal}>✖︎</span>
              <div className="modal_icon success_icon">
                <CheckCircle className="icon" />
              </div>
              <p className="modal_title">{sentence}完了</p>
              <p className="modal_subtitle">住所の{sentence}が完了しました。</p>
            </div>
          </div>
        )}

        {/* 新規追加モーダル */}
        {showModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content address_form_modal" onClick={(e) => e.stopPropagation()}>
              <span className="close-button" onClick={closeModal}>✖︎</span>
              
              <div className="form_header">
                <MapPin className="form_header_icon" />
                <h3>新しい住所を追加</h3>
              </div>

              <div className="modern_form_container">
                <div className="form_field">
                  <label className="form_label">
                    郵便番号<span className="required_mark">※必須</span>
                  </label>
                  <input
                    type="text"
                    value={zip}
                    className="modern_input"
                    placeholder="例: 123-4567"
                    onChange={(e) => setZip(e.target.value)}
                    required
                  />
                </div>

                <div className="form_field">
                  <label className="form_label">
                    住所<span className="required_mark">※必須</span>
                  </label>
                  <input
                    type="text"
                    value={address}
                    className="modern_input"
                    placeholder="例: 東京都渋谷区1-2-3"
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  />
                </div>

                <div className="form_field">
                  <label className="form_label">建物・マンション名</label>
                  <input
                    type="text"
                    value={apartment}
                    className="modern_input"
                    placeholder="例: ○○マンション101号室"
                    onChange={(e) => setApartment(e.target.value)}
                  />
                </div>

                <button
                  className={`modal_submit_button ${isFormValid ? 'active' : 'disabled'}`}
                  onClick={isFormValid ? createAddress : null}
                  disabled={!isFormValid}
                >
                  <Plus className="button_icon" />
                  住所を登録
                </button>
              </div>
            </div>
          </div>
        )}

        {/* 編集モーダル */}
        {editModal && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content address_form_modal" onClick={(e) => e.stopPropagation()}>
              <span className="close-button" onClick={closeModal}>✖︎</span>
              
              <div className="form_header">
                <Edit className="form_header_icon" />
                <h3>住所を編集</h3>
              </div>

              <div className="modern_form_container">
                <div className="form_field">
                  <label className="form_label">
                    郵便番号<span className="required_mark">※必須</span>
                  </label>
                  <input
                    type="text"
                    value={zip}
                    className="modern_input"
                    placeholder="例: 123-4567"
                    onChange={(e) => setZip(e.target.value)}
                    required
                  />
                </div>

                <div className="form_field">
                  <label className="form_label">
                    住所<span className="required_mark">※必須</span>
                  </label>
                  <input
                    type="text"
                    value={address}
                    className="modern_input"
                    placeholder="例: 東京都渋谷区1-2-3"
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  />
                </div>

                <div className="form_field">
                  <label className="form_label">建物・マンション名</label>
                  <input
                    type="text"
                    value={apartment}
                    className="modern_input"
                    placeholder="例: ○○マンション101号室"
                    onChange={(e) => setApartment(e.target.value)}
                  />
                </div>

                <button
                  className={`modal_submit_button ${isFormValid ? 'active' : 'disabled'}`}
                  onClick={isFormValid ? updateAddress : null}
                  disabled={!isFormValid}
                >
                  <Edit className="button_icon" />
                  住所を更新
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MypageAddressContainer;